import { render } from "./AppNavigationMyMapsItem.vue?vue&type=template&id=154712f0&scoped=true"
import script from "./AppNavigationMyMapsItem.vue?vue&type=script&lang=js"
export * from "./AppNavigationMyMapsItem.vue?vue&type=script&lang=js"

import "./AppNavigationMyMapsItem.vue?vue&type=style&index=0&id=154712f0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154712f0"]])

export default __exports__